"use client";

import React from "react";
import classNames from "classnames";

import { Typography } from "@/components/Typography";

import { SsoProviderIcon } from "./SsoProviderIcon";
import { SSOButtonProps } from "../types";
import "./ssoAuthButton.scss";

export const SSOAuthButton = ({
  provider,
  label,
  loadingLabel,
  isShowingLoadingLabel,
  isSsoLocked,
  isFormLoading,
  rounded,
  onClick,
  type = "button",
  ariaLabel,
  ariaBusy,
}: SSOButtonProps) => {
  const isDisabled = isSsoLocked || Boolean(isFormLoading);
  const displayText = isShowingLoadingLabel && !isFormLoading ? loadingLabel : label;

  const rootClassNameMerged = classNames("sso-auth-button", `sso-auth-button--${provider}`, {
    "sso-auth-button--rounded": rounded,
    "sso-auth-button--disabled": isDisabled,
  });

  const resolvedAriaLabel = ariaLabel ?? label;

  const content = (
    <>
      <span className="sso-auth-button__icon-wrap">
        <SsoProviderIcon provider={provider} />
      </span>
      <Typography
        Tag="span"
        classname="sso-auth-button__label"
      >
        {displayText}
      </Typography>
    </>
  );

  return (
    <button
      type={type}
      className={rootClassNameMerged}
      disabled={isDisabled}
      aria-busy={ariaBusy}
      aria-label={resolvedAriaLabel}
      onClick={() => {
        if (!isDisabled) {
          onClick();
        }
      }}
    >
      {content}
    </button>
  );
};
